import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import '../assets/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/ru-RU'

Vue.use(Element, { locale })
